var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading",style:('height: ' + _vm.height + 'px; line-height: ' + _vm.height + 'px;')},[_c('b-spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }